// extracted by mini-css-extract-plugin
export default {"form":"AliasForm_form__XqKSq","button":"AliasForm_button__SmO2r"};